<template>
  <!-- Плитки категорий 3×2 (f01-f03): наведение - кремовая заливка, выбор - ещё и обводка -->
  <div class="category-tiles" role="radiogroup" aria-label="С чем нужна помощь?">
    <button
      v-for="item in categories"
      :key="item.code"
      type="button"
      role="radio"
      class="category-tiles__tile"
      :class="{ 'category-tiles__tile--selected': item.code === value }"
      :aria-checked="item.code === value"
      @click="$emit('input', item.code)"
    >
      <v-icon size="20" class="category-tiles__icon">
        {{ item.icon }}
      </v-icon>
      {{ item.label }}
    </button>
  </div>
</template>

<script>
  import { CATEGORIES } from '../form'

  export default {
    name: 'CategoryTiles',
    props: {
      value: { type: String, default: null },
    },
    data () {
      return { categories: CATEGORIES }
    },
  }
</script>

<style scoped lang="less">
@import '../tokens.less';

.category-tiles {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.category-tiles__tile {
  display: flex;
  gap: 10px;
  align-items: center;
  height: 60px;
  padding: 0 14px;
  border: 1.5px solid transparent;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  color: @fakt-text;
  background: @fakt-surface;
  transition: background-color 0.16s ease;

  &:hover {
    background: @fakt-cream-plate;

    .category-tiles__icon {
      color: @fakt-orange !important;
    }
  }

  &--selected {
    border-color: @fakt-orange;
    background: @fakt-cream-plate;

    .category-tiles__icon {
      color: @fakt-orange !important;
    }
  }
}

.category-tiles__icon {
  color: @fakt-text-2 !important;
  transition: color 0.16s ease;
}

.media-xs({
  .category-tiles {
    grid-template-columns: 1fr;
  }
});
</style>
